
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SessionService } from 'src/app/core/services/session.service';
import { environment } from 'src/app/environments/environment';


@Injectable({ providedIn: 'root' })
export class PdfService {
  // ✅ Use environment.apiUrl
  private apiBase = environment.apiUrl;

  constructor(
    private http:           HttpClient,
    private sessionService: SessionService
  ) {}

  // ✅ Called from job-log component — single job
  async generateJobLogsPdf(
    jobId:         string,
    logs:          any[],
    getWorkerName: (id: string) => string
  ): Promise<void> {
    return this.downloadPdf(
      `${this.apiBase}/api/jobs/${jobId}/report`,
      `job-report-${jobId.slice(0, 8)}.pdf`
    );
  }

  // ✅ Called from reports component — passes current filters to backend
  async generateAllJobsReport(filters?: {
    dateFrom?: string;
    dateTo?:   string;
    workerId?: string;
    jobId?:    string;
  }): Promise<void> {
    const params = new URLSearchParams();

    if (filters?.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters?.dateTo)   params.append('dateTo',   filters.dateTo);
    if (filters?.workerId) params.append('workerId', filters.workerId);
    if (filters?.jobId)    params.append('jobId',    filters.jobId);

    const query = params.toString();
    const url   = `${this.apiBase}/api/jobs/report/all${query ? '?' + query : ''}`;

    return this.downloadPdf(
      url,
      `activity-report-${new Date().toISOString().slice(0, 10)}.pdf`
    );
  }

  // ✅ Shared download helper
  private async downloadPdf(url: string, fallbackName: string): Promise<void> {
    const token = this.sessionService.getAccessToken();

    const response = await fetch(url, {
      method:  'GET',
      headers: { 'Authorization': `Bearer ${token}` }
    });

    if (!response.ok)
      throw new Error(`PDF request failed: ${response.status}`);

    const blob      = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const a         = document.createElement('a');

    a.href     = objectUrl;
    a.download = fallbackName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(objectUrl);
  }
}